import { render } from "./DocumentFormDefinitionsEditor.vue?vue&type=template&id=da79a608&scoped=true"
import script from "./DocumentFormDefinitionsEditor.vue?vue&type=script&lang=js"
export * from "./DocumentFormDefinitionsEditor.vue?vue&type=script&lang=js"

import "./DocumentFormDefinitionsEditor.vue?vue&type=style&index=0&id=da79a608&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da79a608"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QSelect,QInput,QBanner,QToggle,QBtn});
